
import { api } from './config'

////////////////////
// ERROR HANDLING //
////////////////////

export function errorHandling(err) {
  if (err.response) {
    // Server responded with a status other than 200 range

    if (err.response.status === 404) {
      alert('Error: Page Not Found');
    }
  } else if (err.request) {
    // Request was made but no response
    console.error(err.request);
  } else {
    console.error(err.message);
  }
}
/////////////////
// API HANDLER //
/////////////////

export const ApiHandler = async (url, data, config) => {
  const method = data ? "post" : "get"
  return await api[method](url, data, config)
}


/////////////////////////////
// CONTACT SERVICE HANDLER //
/////////////////////////////

export const contactHandler = (e) => {
  e.preventDefault();
  window.location = 'mailto:service@suitsupply.com';
}


//////////////////////////
// CUSTOM EVENT HANDLER //
//////////////////////////

export const customEventHandler = (name) => {
  const newEvent = new CustomEvent(name);
  document.dispatchEvent(newEvent);
}